import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../core/_base/crud';
import { select, Store } from '@ngrx/store';
import { currentAuthToken, currentUser } from 'src/app/core/auth/_selectors/auth.selectors';
import { AppState } from '../../core/reducers';
import { environment } from '../../../environments/environment';

const API_URL = environment.NOTIFICATION_BASE;

@Injectable()
export class CompanyNotificationService {
  private authToken;
  private companyId;
  private userId;
  private level;
  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((user) => {
      this.companyId = user.companyID;
      this.userId = user.id;
    });
  }

  getCompanyNotifications(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    const url =
      API_URL +
      `/companies/${this.companyId}/notifications?page=${pageIndex}&size=${pageSize}&level=${this.level}&related_id=${this.userId}`;
    return this.http.get<QueryResultsModel>(url, { headers: httpHeaders });
  }

  updateCompanyNotification(companyNotification: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      API_URL +
      `/companies/${this.companyId}/notifications/${companyNotification.id}/configuration`;
    return this.http.put(url, companyNotification, { headers: httpHeaders });
  }
  updateCompanyNotificationAll(notificationId: number, payload: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      API_URL +
      `/companies/${this.companyId}/notifications/${notificationId}/update/${payload.notificationConfiguration.level}`;
    return this.http.put(url, payload, { headers: httpHeaders, responseType: 'text' as 'json' });
  }
  updateChannel(channel: any): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url =
      API_URL +
      `/companies/${this.companyId}/notifications/${channel.notification_id}/channels/${channel.id}/configuration`;
    return this.http.put(url, channel, { headers: httpHeaders });
  }
  updateCriteriaGroups(notificationId: number, payload: any): Observable<any> {
    const url = `${API_URL}/notifications/${notificationId}/criteria/`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<any>(url, payload, {
      headers: httpHeaders,
      responseType: 'text' as 'json',
    });
  }
  deleteCompanyNotification(id: number): Observable<any> {
    const url = API_URL + `/companies/${this.companyId}/channel_configurations/${id}`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.delete<any>(url, { headers: httpHeaders });
  }
  saveCriteriaGroups(notificationId: number, payload: any): Observable<any> {
    const url = `${API_URL}/notifications/${notificationId}/criteria/`;
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, payload, { headers: httpHeaders });
  }

  getCriteriaValuesGroups(notificationId: number, level): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = API_URL + `/notifications/${notificationId}/criteria/${level}`;
    return this.http.get<QueryResultsModel>(url, { headers: httpHeaders });
  }
}
